<template>
  <svg class="fts-moji" :width="size" :height="size" :style="styles" v-if="emoji">
    <use :xlink:href="`${twemoji}#${e2u(emoji)}`" />
  </svg>
</template>

<script>
//https://app.inistate.com/twemoji/emoji.svg
import twemoji from "../../assets/twemoji/emoji.svg";

export default {
  props: {
    emoji: String,
    size: {
      type: Number,
      default: 25
    },
  },
  data: () => ({
    twemoji: twemoji
  }),
  methods: {
    e2u(unicodeSurrogates, sep) {
      // console.log(`${unicodeSurrogates} length ${unicodeSurrogates.length}`)
      var
        r = [],
        c = 0,
        p = 0,
        i = 0;

      while (i < unicodeSurrogates.length) {
        c = unicodeSurrogates.charCodeAt(i++);
        if (p) {
          r.push((0x10000 + ((p - 0xD800) << 10) + (c - 0xDC00)).toString(16));
          p = 0;
        } else if (0xD800 <= c && c <= 0xDBFF) {
          p = c;
        } else {
          r.push(c.toString(16));
        }
      }
      return r.join(sep || '-');
    }
  },
  computed: {
    styles() {
      return {
        minWidth: `${this.size}px`
      }
    }
  }
};
</script>

<style lang="scss" scope>
.fts-moji {
  display: block;
}
</style>